// Copyright (C) 2012 Minted Inc.
// All Rights Reserved
var module; UMD(module, {
  'minted:vendor/underscore-1.8.2.min': '_',
  'minted:vendor/jquery-1.9.1.min': '$',
  'minted:vendor/backbone-1.0.0.min': 'Backbone',
  'minted:m': ['M'],
  'minted:vendor/jquery.cycle': [],
  'templito:cycler': [],
  'minted:collection/cycler_slides': []
})(this, function (_, $, Backbone, m_module) {

var M = m_module.M;

M.View = M.View || {};

/**
 * @class M.View.Cycler
 *
 * Renders a cycler widget with pagination.
 *
 * TODO: Port homepage cycler code to use these Backbone classes.
 */
M.View.Cycler = Backbone.View.extend({
  className: 'cyclerWrapper',
  tagName: 'div',

  _getTemplate: function(cssClass) {
    var template = M.Template.Cycler.Default; // Default template, e.g. homepage
    if (cssClass == 'cyclerBannerArt') {
      template = M.Template.Cycler.Art;
    } else if (cssClass == 'cyclerBannerWedding') {
      template = M.Template.Cycler.Wedding;
    } else if (cssClass == 'cyclerWeddingWebsites') {
      template = M.Template.Cycler.WeddingWebsites;
    }
    return template;
  },

  initialize: function() {
    this.collection = new M.Collection.CyclerSlides(this.options.cyclerJson);

    this.template = this._getTemplate(this.options.cssClass);

    var templateVariables = {
      slides: this.collection.models,
      width: this.options.width,
      height: this.options.height,
      IE8: M.getBrowserVersionInt('MSIE ') == 8
    };
    this.html = this.template(templateVariables);
  },

  events: {
    'click .cyclerControls li a': 'pagerClick'
  },

  render: function() {
    this.$el = $(this.el);
    this.$el.append(this.html);

    var $cycler = this.$el.find('.cycler');
    $cycler.addClass(this.options.cssClass);
    $cycler.cycle({
      timeout: 6000,
      speed: 250,
      pager: '#cyclerControls',
      activePagerClass: 'active',
      pause: 1
    });
    return this;
  },

  /*
   * Pause the cycler, move to the selected cycler page.
   */
  pagerClick: function(ev) {
    var $cycler = this.$el.find('.cycler');
    var $pagerLink = $(ev.target);

    // Visually select the clicked pager
    $pagerLink.parents('.cyclerControls').find('li').removeClass('active');
    $pagerLink.parents('li').addClass('active');

    // Move to the selected slide and pause the slideshow
    $cycler.cycle($pagerLink.data('slide-id'));
    $cycler.cycle('pause');
  }
});

return {};
});
